// extracted by mini-css-extract-plugin
module.exports = {"basicLayout__wrapper":"basicLayout__wrapper","basicLayout__header":"basicLayout__header","basicLayout__header__inner":"basicLayout__header__inner"};